/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../resources/credit_line_transaction';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "service": {
            "nested": {
              "SearchTransactionsRequest": {
                "fields": {
                  "creditLineId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "query": {
                    "type": ".squareup.corporate_card.service.SearchTransactionsRequest.SearchTransactionsQuery",
                    "id": 2,
                    "rule": "optional"
                  },
                  "cursor": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "limit": {
                    "type": "int32",
                    "id": 4,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "SearchTransactionsQuery": {
                    "fields": {
                      "filter": {
                        "type": ".squareup.corporate_card.service.SearchTransactionsRequest.SearchTransactionsQuery.SearchTransactionsFilter",
                        "id": 1,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "SearchTransactionsFilter": {
                        "fields": {
                          "descriptionMatches": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "types": {
                            "type": ".squareup.corporate_card.resources.CreditLineTransaction.Type",
                            "id": 2,
                            "rule": "repeated"
                          },
                          "includedTypes": {
                            "type": "string",
                            "id": 3,
                            "rule": "repeated"
                          },
                          "states": {
                            "type": "string",
                            "id": 4,
                            "rule": "repeated"
                          },
                          "excludeDeclinedPurchasesAfterClosure": {
                            "type": "bool",
                            "id": 5,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  }
                }
              },
              "SearchTransactionsResponse": {
                "fields": {
                  "transactions": {
                    "type": ".squareup.corporate_card.resources.CreditLineTransaction",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "cursor": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 3,
                    "rule": "repeated"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.SearchTransactionsRequest && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.SearchTransactionsRequest?.nested?.SearchTransactionsQuery && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.SearchTransactionsRequest?.nested?.SearchTransactionsQuery?.nested?.SearchTransactionsFilter && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.SearchTransactionsResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE SearchTransactionsRequest @ squareup/corporate_card/service/search_transactions.proto at 9:1
 */
export const SearchTransactionsRequest = $root.lookupType('squareup.corporate_card.service.SearchTransactionsRequest');
fixType(SearchTransactionsRequest);
Builder.createAndAttachToType(SearchTransactionsRequest);
/**
 * SOURCE SearchTransactionsQuery @ squareup/corporate_card/service/search_transactions.proto at 10:3
 */
SearchTransactionsRequest.SearchTransactionsQuery = $root.lookupType('squareup.corporate_card.service.SearchTransactionsRequest.SearchTransactionsQuery');
fixType(SearchTransactionsRequest.SearchTransactionsQuery);
Builder.createAndAttachToType(SearchTransactionsRequest.SearchTransactionsQuery);
/**
 * SOURCE SearchTransactionsFilter @ squareup/corporate_card/service/search_transactions.proto at 11:5
 */
SearchTransactionsRequest.SearchTransactionsQuery.SearchTransactionsFilter = $root.lookupType('squareup.corporate_card.service.SearchTransactionsRequest.SearchTransactionsQuery.SearchTransactionsFilter');
fixType(SearchTransactionsRequest.SearchTransactionsQuery.SearchTransactionsFilter);
Builder.createAndAttachToType(SearchTransactionsRequest.SearchTransactionsQuery.SearchTransactionsFilter);
/**
 * SOURCE SearchTransactionsResponse @ squareup/corporate_card/service/search_transactions.proto at 76:1
 */
export const SearchTransactionsResponse = $root.lookupType('squareup.corporate_card.service.SearchTransactionsResponse');
fixType(SearchTransactionsResponse);
Builder.createAndAttachToType(SearchTransactionsResponse);